import { useMemo } from 'react';
import { getMobileOperatingSystem } from '../utils/userAgent';

export const useIsAndroid = () => useMemo(() => getMobileOperatingSystem() === 'android', []);
export const useIsIOS = () => useMemo(() => getMobileOperatingSystem() === 'ios', []);
